import React, { useContext, useRef, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import ListComponent from './ListComponent';
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "../../../../../../assets/img/svg/upwardArrow.svg";
import { checkDuplicateEntry, initialRows } from './constant';
import { RolePermissions } from 'appContext';
import { PermissionContext } from 'appContext';
import { pages } from 'views/pages/manage/common/constant';
const ActiveContact = ({
    dropdown,
    setRowForm,
    rowForm,
    setActiveContactRows,
    activeContactRows,
    editSaveHandler,
    isView,
    basicForm,
    branchMappingRows
}) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [isNew, setIsNew] = useState(false)
    const [open, setOpen] = useState(true)
    const listRef = useRef()
    const userPermissions = RolePermissions(
        useContext(PermissionContext),
        pages["schoolMaster"]["id"]
    );
    const createHandler = (rowForm) => {
        setActiveContactRows((prev) => ([{ ...rowForm, isNew: false }, ...prev]))
        listRef.current.stopEditing();
        isView && editSaveHandler(basicForm, rowForm,
            {
                isBasicFieldsChanged: false,
                isContactsChanged: true,
                isBranchMappingChanged: false
            }
        )

    }
    const updateHandler = (rowForm) => {
        const index = activeContactRows.findIndex(item => item.id === rowForm?.id);
        if (index !== -1) {
            let tempList = [...activeContactRows]
            tempList[index] = { ...rowForm };
            isView && editSaveHandler(basicForm, rowForm,
                {
                    isBasicFieldsChanged: false,
                    isContactsChanged: true,
                    isBranchMappingChanged: false
                }
            )
            setActiveContactRows(tempList);
        }
        listRef.current.stopEditing();
    }
    return (
        <Card>
            <CardBody>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='dark-text label-color'>Active Contacts</div>
                    <div className='d-flex justify-content-between align-items-center' style={{ gap: '8px' }}>
                        {(userPermissions?.includes("C") || userPermissions?.includes("U")) && open && <div className='color-dark  p-2 br-8 cursor' style={{ fontSize: '45px', border: '1px solid #EEEEEE' }} onClick={() => listRef?.current?.addNewRow()} >+</div>}
                        <div className='  p-2 br-8 cursor' style={{ border: '1px solid #EEEEEE' }} onClick={() => { setOpen((prev) => (!prev)); setRowForm({});}}>{open ? <Uparrow /> : <DownArrow />}</div>
                    </div>
                </div>
                {open && <><div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                    <ListComponent ref={listRef}
                        rows={activeContactRows}
                        //   loader={loader}
                        //   dropdown={dropdownData}
                        createHandler={createHandler}
                        updateHandler={updateHandler}
                        //deleteHandler={deleteHandler}
                        currentPage={currentPage}
                        rowCount={rowCount}
                        isNew={isNew}
                        setIsNew={setIsNew}
                        dropdown={dropdown}
                        setRowForm={setRowForm}
                        rowForm={rowForm}
                    />
                </>
                }

            </CardBody>
        </Card>
    )
}
export default ActiveContact